import { useEffect, useState } from 'react';
import { FrontendExtensionProps } from '../../../common/ExtensionWrapper/interfaces';
import { Select, Spin } from 'antd';
import ButtonAction from '../../../common/Buttons/ButtonAction';
import './FinnegansFormaDePago.less';

interface ExtraData {
  paymentMethod: PaymentMethod;
}

enum PaymentMethod {
  contado = 'Contado',
  cuentaCorriente = 'Cuenta Corriente',
}

const FinnegansFormaDePago = (props: FrontendExtensionProps) => {
  const [error, setError] = useState<any>();
  const [extraData, setExtraData] = useState<ExtraData>();

  const initializeData = async () => {
    try {
      const extraData = await props.getExtensionDocumentInformation();

      if (!extraData) {
        setError('Extra data not found');
        return;
      }

      if (!extraData.paymentMethod) {
        // El valor seleccionado por defecto sera Cuenta Corriente
        extraData.paymentMethod = PaymentMethod.cuentaCorriente;
      }

      setExtraData(extraData);
    } catch (error) {
      setError(error);
      return;
    }
  };

  const saveExtensionData = async () => {
    return props.setExtensionDocumentInformation(extraData);
  };

  const handleFinishExtension = async () => {
    try {
      await saveExtensionData();
      await props.finishExtensionStep();
      props.setIsCompleted(props.resourceId, props.receiptCurrentStep);
      props.validateReceipts();
    } catch (error) {
      setError(error);
      return;
    }
  };

  useEffect(() => {
    /* Intencional para que los errores puedan ser capturados por el Error Boundary */
    if (error) {
      throw new Error(error);
    }
  }, [error]);

  useEffect(() => {
    initializeData().catch((error) => {
      setError(error);
    });
  }, []);

  return (
    <div className="extension">
      {extraData ? (
        <>
          <div className="payment-method">
            <span className="payment-method__title extension-label">
              Proceso de Registración
            </span>
            <Select
              options={[
                {
                  label: PaymentMethod.cuentaCorriente,
                  value: PaymentMethod.cuentaCorriente,
                },
                { label: PaymentMethod.contado, value: PaymentMethod.contado },
              ]}
              defaultValue={extraData.paymentMethod}
              size="large"
              onChange={(value: string) => {
                setExtraData({
                  ...extraData,
                  paymentMethod: value as PaymentMethod,
                });
              }}
            />
            <span className="helpText">
              Forma en que se registrará el comprobante y su pago en Finnegans
            </span>
          </div>
          <div style={{ textAlign: 'right' }}>
            <ButtonAction
              style={{ marginLeft: 10, marginTop: '25px' }}
              onClick={handleFinishExtension}
            >
              Guardar
            </ButtonAction>
          </div>
        </>
      ) : (
        <div className="extension__spin">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default FinnegansFormaDePago;
